import { render } from "./HosAccManage.vue?vue&type=template&id=061562ea&scoped=true"
import script from "./HosAccManage.vue?vue&type=script&lang=js"
export * from "./HosAccManage.vue?vue&type=script&lang=js"

import "./HosAccManage.vue?vue&type=style&index=0&id=061562ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061562ea"]])

export default __exports__